<template>
    <div class="accordion" id="order">
        <CardCollapse v-if="requesterEnable" id="requester" :completed="requesterCompleted" :disabled="!requesterVisible" :show="true" icon="user" label="Requester" parent="#order">
            <RequesterForm/>
        </CardCollapse>
        <CardCollapse id="sender" :completed="senderCompleted" :disabled="!senderVisible" icon="address-card" label="Sender" parent="#order">
            <AddressForm id="sender" :create="senderCreate"/>
        </CardCollapse>
        <CardCollapse id="recipient" :completed="recipientCompleted" :disabled="!recipientVisible" icon="address-card" label="Recipient" parent="#order">
            <AddressForm id="recipient"/>
        </CardCollapse>
        <CardCollapse id="parcel" :completed="parcelCompleted" :disabled="!parcelVisible" icon="box-open" label="Parcel" parent="#order">
            <ParcelForm :max-weight="parcelMaxWeight" :max-height="parcelMaxHeight" :max-width="parcelMaxWidth" :max-length="parcelMaxLength"/>
        </CardCollapse>
        <CardCollapse id="service" :completed="serviceCompleted" :disabled="!serviceVisible" icon="shipping-fast" label="Service" parent="#order">
            <ServiceForm :show-price="serviceShowPrice"/>
        </CardCollapse>
        <CardCollapse id="insurance" :completed="insuranceCompleted" :disabled="!insuranceVisible" icon="shield-alt" label="Insurance" parent="#order">
            <InsuranceForm :show-cost="insuranceShowCost"/>
        </CardCollapse>
        <CardCollapse id="payment" :disabled="!paymentVisible" icon="credit-card" label="Payment" parent="#order">
            <PaymentForm :offline="paymentOffline" :show-price="paymentShowPrice"/>
        </CardCollapse>
    </div>
</template>

<script>
import CardCollapse from "../CardCollapse";
import RequesterForm from "./RequesterForm";
import AddressForm from "./AddressForm";
import ParcelForm from "./ParcelForm";
import ServiceForm from "./ServiceForm";
import InsuranceForm from "./InsuranceForm";
import PaymentForm from "./PaymentForm";

export default {
    name: "OrderForm",
    components: {CardCollapse, RequesterForm, AddressForm, ParcelForm, InsuranceForm, ServiceForm, PaymentForm},
    props: {
        requesterEnable: {type: Boolean},
        senderCreate: {type: Boolean},
        parcelMaxWeight: {type: Number},
        parcelMaxHeight: {type: Number},
        parcelMaxWidth: {type: Number},
        parcelMaxLength: {type: Number},
        serviceShowPrice: {type: Boolean},
        insuranceShowCost: {type: Boolean},
        paymentOffline: {type: Boolean},
        paymentShowPrice: {type: Boolean},
    },
    computed: {
        requesterCompleted() {
            return this.$store.getters['order/requester/completed'];
        },
        senderCompleted() {
            return this.$store.getters['order/sender/completed'];
        },
        recipientCompleted() {
            return this.$store.getters['order/recipient/completed'];
        },
        parcelCompleted() {
            return this.$store.getters['order/parcel/completed'];
        },
        serviceCompleted() {
            return this.$store.getters['order/quote/completed'];
        },
        insuranceCompleted() {
            return this.$store.getters['order/insurance/completed'];
        },
        requesterVisible() {
            return true;
        },
        senderVisible() {
            return this.requesterVisible && (this.requesterCompleted || !this.requesterEnable);
        },
        recipientVisible() {
            return this.senderVisible && this.senderCompleted;
        },
        parcelVisible() {
            return this.recipientVisible && this.recipientCompleted;
        },
        serviceVisible() {
            return this.parcelVisible && this.parcelCompleted;
        },
        insuranceVisible() {
            return this.serviceVisible && this.serviceCompleted;
        },
        paymentVisible() {
            return this.insuranceVisible && this.insuranceCompleted;
        },
    },
}
</script>
